class SearchDrawer extends HTMLElement {
    constructor() {
        super();
        this.searchButtons = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.searchButton}`);
        this.setupSearchToggle();

        this.addEventListener('click', (event) => {
            event.stopPropagation();
        });

        document.addEventListener('click', (event) => this.handleOutsideClick(event));
    }

    setupSearchToggle() {
        if (!this.searchButtons.length) return;

        this.searchButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.toggle(button);
            });
        });
    }

    toggle(button) {
        if (this.classList.contains('active')) {
            this.close(button);
        } else {
            this.open(button);
        }
    }

    removeClassModal() {
        const modalActive = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.modal}`);
        const headerIconActive = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.headerIconClass}`);

        modalActive.forEach((modal) => modal.classList.remove('active'));
        headerIconActive.forEach((icon) => icon.classList.remove('active'));
    }

    open(button) {
        this.removeClassModal();
        button.classList.add('active');
        this.classList.add('active');
    }

    close(button) {
        if (button) button.classList.remove('active');
        this.classList.remove('active');
    }

    handleOutsideClick(event) {
        const isButtonClicked = Array.from(this.searchButtons).some((button) => button.contains(event.target));
        
        if (this.contains(event.target) || isButtonClicked) {
            return;
        }

        this.searchButtons.forEach((button) => button.classList.remove('active'));
        this.close();
    }
}

customElements.define('search-drawer-mobile', SearchDrawer);
